import chevronRight from './../../../../../../assets/Navbar/chevronRightIcon.png'
import arrowRightBlackSmall from './../../../../../../assets/Navbar/arrowRightBlackSmall.svg'
import CloseMenuIconBtn from "../CloseMenuIconBtn"
import LinkComponent from '../../../atoms/LinkComponent'
import ButtonComponent from '../../../atoms/ButtonComponent'
import ImageComponent from '../../../atoms/ImageComponent'
import logo from './../../../../../../assets/Navbar/ZOWN-Blue-logo-no-slogan.svg'
import { FC } from 'react'
import { MainPageProps } from './types'
import { buildUrlUsingBase } from '../../../../../../constants'

const MainPage: FC<MainPageProps> = ({ navigateFn, handleReset }) => {
    return (
        <div
            id="mob-nav-main"
            className="fixed inset-y-0 right-0 z-[100] w-[91%] overflow-y-auto bg-white p-[32px] flex flex-col gap-[32px] mobile-nav-page"
        >
            <div className="flex items-center justify-between">
                <LinkComponent to="https://www.zown.ca/" className="-m-1.5 p-1.5">
                    <span className="sr-only">Zown CA</span>
                    <ImageComponent
                        width="95px"
                        height="53px"
                        source={logo}
                        alt="logo"
                    />
                </LinkComponent>
                <CloseMenuIconBtn handleClick={() => handleReset()} />
            </div>
            <div className="space-y-2">
                <button
                    className="w-full rounded-lg py-[10px] text-base/7 font-semibold text-gray-900 hover:bg-gray-50 justify-between flex mob-nav-page-change-btn"
                    onClick={() => {
                        navigateFn('buy')
                    }}
                >
                    <div className="font-bold text-[20px] leading-[36px]">Buy</div>
                    <ImageComponent
                        source={chevronRight}
                        alt="chevron-right"
                        width="36px"
                        height="36px"
                    />
                </button>
                <button
                    data-nav-target="mob-nav-sell"
                    className="w-full rounded-lg py-[10px] text-base/7 font-semibold text-gray-900 hover:bg-gray-50 justify-between flex mob-nav-page-change-btn"
                    onClick={() => {
                        navigateFn('sell')
                    }}
                >
                    <div className="font-bold text-[20px] leading-[36px]">Sell</div>
                    <ImageComponent
                        source={chevronRight}
                        alt="chevron-right"
                        width="36px"
                        height="36px"
                    />
                </button>
                <button
                    data-nav-target="mob-nav-buy-sell"
                    className="w-full rounded-lg py-[10px] text-base/7 font-semibold mob-nav-page-change-btn text-gray-900 hover:bg-gray-50 justify-between flex"
                    onClick={() => {
                        navigateFn('sell-buy')
                    }}
                >
                    <div className="font-bold text-[20px] leading-[36px]">
                        Upsize
                    </div>
                    <ImageComponent
                        source={chevronRight}
                        alt="chevron-right"
                        width="36px"
                        height="36px"
                    />
                </button>
            </div>
            <div className="flex flex-col gap-[10px]">
                <LinkComponent to={buildUrlUsingBase('buyer/down-payment-qualification')}
                ><ButtonComponent variant="contained" size="large" className="!h-[50px]   w-full">
                        Get Qualified
                        <span className="ml-[5px]">
                            <ImageComponent
                                width="10px"
                                height="10px"
                                source={arrowRightBlackSmall}
                                alt="arrow-right"
                            />
                        </span>
                    </ButtonComponent>
                </LinkComponent>
                <LinkComponent to={'https://homes.zown.ca'}>
                    <ButtonComponent variant="none" size="large" className=" !h-[50px] shadow-md w-full">
                        Browse Homes
                        <span className="ml-[5px]">
                            <ImageComponent
                                width="10px"
                                height="10px"
                                source={arrowRightBlackSmall}
                                alt="arrow-right"
                            />
                        </span>
                    </ButtonComponent>
                </LinkComponent>
            </div>
            <div className="flex flex-col gap-0">
                <div className="font-medium text-[12px] leading-[200%] text-[#1a1a1a]">
                    How Zown Changes Real Estate
                </div>
                <LinkComponent to={buildUrlUsingBase('buyer/')}>
                    <div className="font-medium text-[16px] leading-[36px] text-[#1a1a1a]">Down Payment Program</div>
                </LinkComponent>
                <LinkComponent to={buildUrlUsingBase('buyer/mortgage-pre-qualification')}>
                    <div className="font-medium text-[16px] leading-[36px] text-[#1a1a1a]">Mortgage Buydown</div>
                </LinkComponent>
                <LinkComponent to={buildUrlUsingBase('buyer/how-it-works')}>
                    <div className="font-medium text-[16px] leading-[36px] text-[#1a1a1a]">Local Agent Network</div>
                </LinkComponent>
            </div>
            <div className="flex flex-col gap-0">
                <div className="font-medium text-[12px] leading-[200%] text-[#1a1a1a]">More From Zown</div>
                <LinkComponent to={buildUrlUsingBase('buyer/the-zown-story')}>
                    <div className="font-medium text-[16px] leading-[36px] text-[#1a1a1a]">Our Story</div>
                </LinkComponent>
                <LinkComponent to={buildUrlUsingBase('buyer/our-team')}>
                    <div className="font-medium text-[16px] leading-[36px] text-[#1a1a1a]">The Team</div>
                </LinkComponent>
                <LinkComponent to={buildUrlUsingBase('buyer/media-center')}>
                    <div className="font-medium text-[16px] leading-[36px] text-[#1a1a1a]">Media Center</div>
                </LinkComponent>
                <LinkComponent to={buildUrlUsingBase('buyer/careers')}>
                    <div className="font-medium text-[16px] leading-[36px] text-[#1a1a1a]">Careers</div>
                </LinkComponent>
                <LinkComponent to={buildUrlUsingBase('buyer/contact-us')}>
                    <div className="font-medium text-[16px] leading-[36px] text-[#1a1a1a]">Contact Us</div>
                </LinkComponent>
            </div>
        </div>
    )
}

export default MainPage